/**
 * Service Forms — staff-built certificates, checklists, maintenance logs, and custom forms.
 */
export const SERVICE_FORM_KINDS = ['certificate', 'checklist', 'maintenance_log', 'custom'];
export const SERVICE_FORM_FIELD_TYPES = [
    'text',
    'textarea',
    'number',
    'date',
    'checkbox',
    'dropdown',
    'signature',
    'grid',
    'paragraph'
];
/** Field types that can be placed in a layout-grid cell (not another grid). Static text first. */
export const SERVICE_FORM_CELL_FIELD_TYPES = [
    'paragraph',
    ...SERVICE_FORM_FIELD_TYPES.filter((t) => t !== 'grid' && t !== 'paragraph')
];
export const SERVICE_FORM_GRID_COLUMN_TYPES = ['text', 'number', 'checkbox', 'dropdown'];
export const SERVICE_FORM_STATUSES = ['draft', 'completed'];
export const SERVICE_FORM_KIND_LABELS = {
    certificate: 'Certificate',
    checklist: 'Checklist',
    maintenance_log: 'Maintenance log',
    custom: 'Custom form'
};
export const SERVICE_FORM_FIELD_TYPE_LABELS = {
    text: 'Text',
    textarea: 'Multiline text',
    number: 'Number',
    date: 'Date',
    checkbox: 'Checkbox',
    dropdown: 'Dropdown',
    signature: 'Signature',
    grid: 'Grid',
    paragraph: 'Static text'
};
/** True when the paragraph heading is the generic default and should not print. */
export function isServiceFormStaticTextDefaultLabel(label) {
    const n = (label || '').trim().toLowerCase();
    return !n || n === 'paragraph' || n === 'static text';
}
/** Known binding keys for default pre-fill */
export const SERVICE_FORM_BINDING_KEYS = [
    'business.name',
    'business.email',
    'business.phone',
    'business.address',
    'business.city',
    'business.state',
    'business.zipCode',
    'business.logo',
    'customer.firstName',
    'customer.lastName',
    'customer.fullName',
    'customer.email',
    'customer.phone',
    /** Commercial / B2B account name (`customers.company`) */
    'customer.company',
    'job.jobNumber',
    'job.title',
    /** Primary technician on the job (`jobs.assignedTechnicianId`) — first + last name */
    'job.assignedTechnician',
    'job.serviceAddress',
    'job.serviceCity',
    'job.serviceState',
    'job.serviceZip',
    'job.scheduledAt',
    'invoice.invoiceNumber',
    ''
];
export function isServiceFormKind(value) {
    return typeof value === 'string' && SERVICE_FORM_KINDS.includes(value);
}
export function isServiceFormFieldType(value) {
    return typeof value === 'string' && SERVICE_FORM_FIELD_TYPES.includes(value);
}
export function isServiceFormGridColumnType(value) {
    return typeof value === 'string' && SERVICE_FORM_GRID_COLUMN_TYPES.includes(value);
}
export function isServiceFormLayoutGrid(def) {
    return def.type === 'grid' && Array.isArray(def.cells);
}
export function isServiceFormTableGrid(def) {
    return def.type === 'grid' && !isServiceFormLayoutGrid(def);
}
//# sourceMappingURL=serviceForms.js.map